module.exports = __webpack_public_path__ + "static/img/hero.ed12abe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hero.jpg
// module id = GTvX
// module chunks = 1